namespace RioERP.Orders {
    export namespace OrderProductBillingItemsTaxService {
        export const baseUrl = 'Orders/OrderProductBillingItemsTax';

        export declare function Create(request: Serenity.SaveRequest<OrderProductBillingItemsTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderProductBillingItemsTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderProductBillingItemsTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrderProductBillingItemsTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/OrderProductBillingItemsTax/Create",
            Update = "Orders/OrderProductBillingItemsTax/Update",
            Delete = "Orders/OrderProductBillingItemsTax/Delete",
            Retrieve = "Orders/OrderProductBillingItemsTax/Retrieve",
            List = "Orders/OrderProductBillingItemsTax/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>OrderProductBillingItemsTaxService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
